import { makeAutoObservable, runInAction } from 'mobx'
import { type CallStore } from 'entities/Call'
import { type Websocket, WebsocketEvent } from 'entities/WebSocket'
import type { UsersStore } from 'entities/Users'

export class ActiveCallingStore {
  private _hasActiveCall = false

  constructor(
    private callStore: CallStore,
    private _usersStore: UsersStore,
    private _websocket: Websocket
  ) {
    makeAutoObservable(this)
    this.initActiveCallsEvent()
  }

  private initActiveCallsEvent = async () => {
    await this._usersStore.initPromise
    this._websocket.subscribe(`calling.${this._usersStore.user_owner_id}.user`)
    this._websocket.on(WebsocketEvent.ClientCalling, this._setHasActiveCall)
  }

  get hasActiveCall() {
    return this._hasActiveCall
  }

  private _activeCallTimeOutId: NodeJS.Timeout | null = null
  private _setHasActiveCall = (value: boolean) => {
    if (this._activeCallTimeOutId) {
      clearTimeout(this._activeCallTimeOutId)
    }
    this._hasActiveCall = value
    this._activeCallTimeOutId = setTimeout(() => {
      runInAction(() => {
        this._hasActiveCall = false
      })
    }, 10000)
  }

  private _callingEventTimeOutId: NodeJS.Timeout | null = null
  sendCallingEvent = (value: boolean) => {
    if (this._callingEventTimeOutId) {
      clearTimeout(this._callingEventTimeOutId)
    }
    this._websocket.sendEvent(
      `calling.${this._usersStore.user_owner_id}.user`,
      'client-calling',
      value
    )
    if (value) {
      this._callingEventTimeOutId = setTimeout(() => {
        this.sendCallingEvent(this.callStore.startedCall)
      }, 5000)
    }
  }
}
